import { render, staticRenderFns } from "./IconAndFontSizePanel.vue?vue&type=template&id=47268b76"
import script from "./IconAndFontSizePanel.vue?vue&type=script&lang=js"
export * from "./IconAndFontSizePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports